<template>
  <AdsButton
    v-bind="$attrs"
    buttonText="Close"
    icon="mdi-close"
    primary
    v-on="$listeners"
  />
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'CloseDialogButton',
  components: {AdsButton}
}
</script>

<style lang="scss" scoped>

</style>
